import { FunctionComponent, useCallback } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

interface FooterProps {
  onClose: (buttonText: string) => void
  onClickNext: (buttonText: string) => void
  isLastStep?: boolean
}

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8, spacing24 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing8};
    align-items: center;
    margin-bottom: ${spacing24};
  `}
`

const StyledPrimaryButton = styled(PrimaryCTAButton)`
  min-width: 162px;
`

const Footer: FunctionComponent<FooterProps> = ({
  onClickNext,
  onClose,
  isLastStep,
}) => {
  const handleClose = useCallback(() => {
    onClose(translate('blickPlusOnboardingModal.finishButton'))
  }, [onClose])
  const handleClickNext = useCallback(() => {
    onClickNext(translate('blickPlusOnboardingModal.nextButton'))
  }, [onClickNext])
  return (
    <StyledWrapper>
      <StyledPrimaryButton
        size={'large'}
        onClick={isLastStep ? handleClose : handleClickNext}
      >
        {translate(
          isLastStep
            ? 'blickPlusOnboardingModal.finishButton'
            : 'blickPlusOnboardingModal.nextButton',
        )}
      </StyledPrimaryButton>
    </StyledWrapper>
  )
}

export default Footer
